import * as fs from "node:fs";
import * as path from "node:path";

import lockfile from "proper-lockfile";

import { CliError, EXIT_RUNTIME } from "../../common.js";

export async function withIngestWorkspaceLock<T>(workspacePath: string, operation: () => Promise<T>): Promise<T> {
  const root = path.resolve(workspacePath);
  fs.mkdirSync(root, { recursive: true });
  let release: (() => Promise<void>) | null = null;
  try {
    release = await lockfile.lock(root, {
      realpath: false,
      stale: 120_000,
      update: 10_000,
      retries: 0,
    });
  } catch (error) {
    throw new CliError("The ingest workspace is busy.", {
      exitCode: EXIT_RUNTIME,
      errorCode: "INGEST_WORKSPACE_BUSY",
      hint: "Wait for the other ingest or skip command to finish, then retry.",
      data: { actual: [root, error instanceof Error ? error.message : String(error)] },
    });
  }
  try {
    return await operation();
  } finally {
    await release();
  }
}
